import { AusActions } from "@aus/Store/AusState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<
    {
        key: string;
        value: string;
    },
    DispatchProp<AusActions>
>;

export const DispatchSetFieldValue: HandlerType = props => {
    props.dispatch({
        type: "Components/DealerAccountRequestForm/SetFieldValue",
        key: props.parameter.key,
        value: props.parameter.value,
    });
};

export const chain = [DispatchSetFieldValue];

const setFieldValue = createHandlerChainRunner(chain, "SetFieldValue");
export default setFieldValue;
